import { TextCodes } from '@api/types/translation/TextCodes';
import { BackButton, Button, Title } from '@components';
import { useAppSelector, useAuth } from '@hooks';
import PrintIcon from '@mui/icons-material/Print';
import { Box, Stack, styled, useMediaQuery, useTheme } from '@mui/material';
import { getSpecialPage } from '@store/app/app.slice';
import { breakpoints } from '@themes/theme.helpers';
import { t } from '@translations';

type WarrantyDetailsHeaderProps = {
  title?: string;
  warrantyNo?: string | null;
};
const Subtitle = styled(Box)`
  font-weight: 600;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.palette.text.secondary};
  ${breakpoints.up('md')} {
    font-size: 24px;
  }
`;
export const WarrantyDetailsHeader: React.FC<WarrantyDetailsHeaderProps> = ({
  title,
  warrantyNo,
}: WarrantyDetailsHeaderProps) => {
  const { isBeremaUser } = useAuth();
  const dealerWarrantyListPage = useAppSelector(getSpecialPage('dealerWarrantyListPage'));
  const beremaWarrantyListPage = useAppSelector(getSpecialPage('beremaWarrantyListPage'));
  const handlePrint = async () => {
    window.print();
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box sx={{ mb: 4 }}>
      <Stack
        direction='row'
        gap={{ xs: 1, sm: 2 }}
        justifyContent='space-between'
        alignItems='center'
        flexWrap='wrap'
      >
        <BackButton href={isBeremaUser ? beremaWarrantyListPage : dealerWarrantyListPage} />

        {isMobile && (
          <Button
            variant='primary'
            onClick={handlePrint}
            size='small'
            sx={{
              mb: 2,
            }}
          >
            <PrintIcon />
          </Button>
        )}
      </Stack>
      <Stack
        direction='row'
        gap={{
          xs: 1,
          sm: 2,
        }}
        justifyContent='space-between'
        alignItems='center'
        flexWrap='wrap'
      >
        <Stack>
          {title && <Title variant='h2'>{title}</Title>}
          {warrantyNo && isMobile && (
            <Subtitle>
              {t(TextCodes.Warranty.Block.ClaimNo)} {warrantyNo}
            </Subtitle>
          )}
        </Stack>

        {!isMobile && (
          <Button variant='primary' onClick={handlePrint} startIcon={<PrintIcon />}>
            {t(TextCodes.Base.Print)}
          </Button>
        )}
      </Stack>
      {warrantyNo && !isMobile && (
        <Subtitle>
          {t(TextCodes.Warranty.Block.ClaimNo)} {warrantyNo}
        </Subtitle>
      )}
    </Box>
  );
};
